// SmallScreenSidebar.js
import React, { useState, useEffect, useRef, useContext } from "react";
import "../../styles/components-styles/sidebar-styles/SmallScreenSidebar.css";
import {
  FaHome,
  FaBook,
  FaEdit,
  FaCheckCircle,
  FaChartLine,
  FaChalkboardTeacher,
  FaChevronDown,
  FaBookOpen,
  FaChevronUp,
  FaQuestionCircle,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../contexts/SidebarContext";

function SmallScreenDashboardSidebar() {
  const navigate = useNavigate();
  const [isPerformanceOpen, setIsPerformanceOpen] = useState(false);
  const sidebarRef = useRef(null);
  const { showSmallScreenSidebar, toggleSmallScreenSidebar } =
    useContext(SidebarContext);

  const togglePerformanceDropdown = () => {
    setIsPerformanceOpen(!isPerformanceOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    toggleSmallScreenSidebar(); // Close the sidebar after navigation
  };

  // Close the sidebar if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        showSmallScreenSidebar
      ) {
        toggleSmallScreenSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSmallScreenSidebar, toggleSmallScreenSidebar]);

  return (
    <div
      ref={sidebarRef}
      className={`small-screen-sidebar-container ${
        showSmallScreenSidebar ? "open" : "close"
      }`}
    >
      {/* Header with Logo and Qbank360 text */}
      <div className="small-screen-sidebar-header">
        <img
          src="qbank_logo.png"
          alt="Logo"
          className="small-screen-sidebar-logo"
        />
        <span className="small-screen-sidebar-title">Qbank360</span>
      </div>

      {/* Sub-header */}
      <div className="small-screen-sidebar-subheader">
        <span>MRCGP Applied Knowledge Test</span>
      </div>

      {/* Navigation/Sidebar Lists */}
      <nav className="small-screen-sidebar-nav">
        {/* Section 1: Home */}
        <ul className="small-screen-sidebar-section">
          <li
            className="small-screen-sidebar-item"
            onClick={() => handleNavigation("/dashboard/home")}
          >
            <FaHome className="small-screen-sidebar-icon" />
            <span>Home</span>
          </li>
        </ul>

        {/* Section 2: QUESTION CONCEPTS */}
        <div className="small-screen-sidebar-section-title">
          <FaQuestionCircle className="small-screen-sidebar-icon" />
          <span>QUESTION CONCEPTS</span>
        </div>
        <ul className="small-screen-sidebar-section">
          <li
            className="small-screen-sidebar-item"
            onClick={() => handleNavigation("/dashboard/question-questionbank")}
          >
            <FaBook className="small-screen-sidebar-icon" />
            <span>Question bank</span>
          </li>
          <li
            className="small-screen-sidebar-item"
            onClick={() => handleNavigation("/dashboard/question-mockexam")}
          >
            <FaEdit className="small-screen-sidebar-icon" />
            <span>Mock exams</span>
          </li>
          <li
            className="small-screen-sidebar-item"
            onClick={() => handleNavigation("/dashboard/question-review")}
          >
            <FaCheckCircle className="small-screen-sidebar-icon" />
            <span>Review questions</span>
          </li>
          <li
            className={`small-screen-sidebar-item dropdown ${
              isPerformanceOpen ? "open" : ""
            }`}
          >
            <div
              className="small-screen-sidebar-dropdown-header"
              onClick={togglePerformanceDropdown}
            >
              <FaChartLine className="small-screen-sidebar-icon" />
              <span>Performance</span>
              {isPerformanceOpen ? (
                <FaChevronUp className="small-screen-sidebar-dropdown-icon" />
              ) : (
                <FaChevronDown className="small-screen-sidebar-dropdown-icon" />
              )}
            </div>
            <ul className="small-screen-sidebar-dropdown-menu">
              <li
                className="small-screen-sidebar-dropdown-item"
                onClick={() => handleNavigation("/dashboard/question-summary")}
              >
                <span>Summary</span>
              </li>
              <li
                className="small-screen-sidebar-dropdown-item"
                onClick={() => handleNavigation("/dashboard/question-overview")}
              >
                <span>Overtime</span>
              </li>
            </ul>
          </li>
        </ul>

        {/* Section 3: KNOWLEDGE TUTOR */}
        <div className="small-screen-sidebar-section-title">
          <span>KNOWLEDGE TUTOR</span>
        </div>
        <ul className="small-screen-sidebar-section">
          <li
            className="small-screen-sidebar-item"
            onClick={() => handleNavigation("/dashboard/knowledge")}
          >
            <FaChalkboardTeacher className="small-screen-sidebar-icon" />
            <span>Knowledge tutor</span>
          </li>
        </ul>

        {/* Section 5: TEXTBOOK */}
        <div className="small-screen-sidebar-section-title">
          <span>TEXTBOOK</span>
        </div>
        <ul className="small-screen-sidebar-section">
          <li
            className="small-screen-sidebar-item"
            onClick={() => handleNavigation("/dashboard/textbook")}
          >
            <FaBookOpen className="small-screen-sidebar-icon" />
            <span>High-yield text book</span>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default SmallScreenDashboardSidebar;
